import { Action } from '@ngrx/store';
import { IUserRole } from '@account-users/user/models/UserRole';

export enum RolesActionTypes {
  LoadRoles = '[Roles] Load Roles',
  LoadRolesSuccess = '[Roles] Load Roles Success',
  LoadRolesFailed = '[Roles] Load Roles Failed',
}

export class LoadRoles implements Action {
  readonly type = RolesActionTypes.LoadRoles;
}

export class LoadRolesSuccess implements Action {
  readonly type = RolesActionTypes.LoadRolesSuccess;
  constructor(public payload: IUserRole[]) {}
}

export class LoadRolesFailed implements Action {
  readonly type = RolesActionTypes.LoadRolesFailed;
}

export type RolesActions = LoadRoles | LoadRolesSuccess | LoadRolesFailed;
